<template>
  <div class="frmware-detail-table-bd">
    <h2 class="table-title">
      {{ $t('dms_firmwareTask_detail_firmwareTable.sheng_ji_xin_xi') }}
    </h2>
    <div class="table-bd">
      <custom-table :index="true" :data="data" :loading="isLoading" :column="tableColumn" @filter="filterChange" @sort="sortChange" :slots="['resourceSize']">
        <template v-slot:resourceSize="scope">
          {{ getResourceSize(scope.row.resourceSize) }}
        </template>
      </custom-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: [String, Object, Array],
  },

  data() {
    return {
      tableCode: 'firmware-info',
    };
  },
  mounted() {
    this.getTableColumn();
  },
  methods: {
    getResourceSize(val) {
      if (val) {
        return (val / 1024).toFixed(2);
      }
      return '-';
    },
  },
};
</script>

<style lang="scss">
.frmware-detail-table-bd {
  flex: initial;
  .table-box {
    flex: 1;
    .table-title {
      height: 60px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      line-height: 60px;
    }

    .table-bd {
      height: 100%;
    }
  }
}
</style>
